import { makeQueryParam, toQueryParam } from './internal/query.js';
import { parseURI } from './parsers.js';
import { ParseQueryError } from '../errors/ParseQueryError.js';
export const mergePaths = (left, right) => {
    const leftPath = left.replace(/\/$/, '');
    const rightPath = right.replace(/^\//, '');
    return `${leftPath}/${rightPath}`;
};
const mergeBaseUriPiece = (baseUriPiece, extensionPiece) => {
    if (typeof extensionPiece === 'undefined') {
        return baseUriPiece;
    }
    if (typeof extensionPiece === 'function') {
        return extensionPiece(baseUriPiece);
    }
    return extensionPiece;
};
export const mergeBaseUri = (baseUri, extension) => {
    const parsedBaseUri = parseURI(baseUri);
    const scheme = mergeBaseUriPiece(parsedBaseUri.scheme, extension.scheme);
    const host = mergeBaseUriPiece(parsedBaseUri.host, extension.host);
    const port = mergeBaseUriPiece(parsedBaseUri.port, extension.port);
    const path = mergeBaseUriPiece(parsedBaseUri.path, extension.path);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const query = mergeBaseUriPiece(parsedBaseUri.query || '', extension.query);
    return {
        host,
        path,
        port,
        query,
        scheme,
    };
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getArrayQuery = (arrParam, key, transformBodyToLegacyString) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const toKey = (val, index) => transformBodyToLegacyString ? makeQueryParam(`${key}[${index}]`, val) : toQueryParam(key, val);
    return arrParam.map(toKey).join('&');
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getObjectQuery = (objParam, key, transformBodyToLegacyString) => {
    if (!transformBodyToLegacyString) {
        throw new ParseQueryError(`Can't parse query string. Value type shouldn't be "object". Key: "${key}"`);
    }
    return makeQueryParam(key, objParam);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const transformObjectToQuery = (obj, transformBodyToLegacyString) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const withoutEmpty = (key) => !!(key.length && obj[key] !== undefined);
    const makeQuery = (key) => {
        const item = obj[key];
        switch (true) {
            case item instanceof Array:
                return getArrayQuery(item, key, transformBodyToLegacyString);
            case item !== null && typeof item === 'object':
                return getObjectQuery(item, key, transformBodyToLegacyString);
            default:
                return toQueryParam(key, item);
        }
    };
    return Object.keys(obj).filter(withoutEmpty).map(makeQuery).join('&');
};
//# sourceMappingURL=helpers.js.map